import React from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import BrandingWatermarkOutlinedIcon from '@mui/icons-material/BrandingWatermarkOutlined';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import Box from '@mui/material/Box';
import PermissionComponent from 'react-redux-permissions';

import SettingsList, { SettingsMenuItem } from '@fd/ui/List/SettingsList';

import Tag from '../../../common/Tag';

export const ConfigurationLinksList = () => {
  const appId = useAppSelector((state) => state.currentApp?.AppId);

  const configMenuItems: SettingsMenuItem[] = [
    // {
    //   title: 'Mobile_Apps_Configuration',
    //   path: 'mobile-apps/configuration?tab=app-store',
    //   icon: <SettingsOutlinedIcon />,
    //   subtitle: 'Configure_mobile_app_settings_and_preferences',
    //   searchAlias: ['Mobile apps settings', 'Mobile apps configuration'],
    //   permissions: ['FlipdishStaff'],
    // },
    {
      title: 'Mobile_apps_build_status',
      path: `/${appId}/mobile-apps-tools/status/android`,
      icon: <AndroidIcon />,
      subtitle: 'Configure_mobile_apps_build_status',
      searchAlias: ['Mobile apps build status', 'Mobile apps status'],
      permissions: ['FlipdishStaff'],
    },
    {
      title: 'Mobile_apps_ios_build_status',
      path: `/${appId}/mobile-apps-tools/status/ios`,
      icon: <AppleIcon />,
      subtitle: 'Configure_mobile_apps_ios_build_status',
      searchAlias: ['iOS app build status', 'iOS app status'],
      permissions: ['FlipdishStaff'],
    },
    {
      title: 'Mobile_apps_app_settings',
      path: `/${appId}/mobile-apps-tools/app-settings`,
      icon: <TuneOutlinedIcon />,
      subtitle: 'Configure_mobile_apps_app_settings',
      searchAlias: ['Mobile apps app settings', 'Mobile apps settings'],
      permissions: ['FlipdishStaff'],
    },
    {
      title: 'Mobile_apps_screenshots',
      path: `/${appId}/mobile-apps-tools/screenshots`,
      icon: <PhotoLibraryOutlinedIcon />,
      subtitle: 'Configure_mobile_apps_screenshots',
      searchAlias: ['Mobile apps screenshots'],
      permissions: ['FlipdishStaff'],
    },
    {
      title: 'Mobile_apps_artifacts',
      path: `/${appId}/mobile-apps-tools/artifacts`,
      icon: <ArchiveOutlinedIcon />,
      subtitle: 'Configure_mobile_apps_artifacts',
      searchAlias: ['Mobile apps artifacts'],
      permissions: ['FlipdishStaff'],
    },
    {
      title: 'Mobile_apps_brand_assets',
      path: `/${appId}/mobile-apps-tools/brand-assets`,
      icon: <BrandingWatermarkOutlinedIcon />,
      subtitle: 'Configure_mobile_apps_brand_assets',
      searchAlias: ['Mobile apps brand assets'],
      permissions: ['FlipdishStaff'],
    },
  ];

  return (
    <PermissionComponent allowed={['FlipdishStaff']}>
      <Box sx={{ marginBottom: 1 }}>
        <Tag showBetaTag noMargin alignSelf="flex-start" tagName="Flipdish_staff_only" />
      </Box>
      <SettingsList menuItems={configMenuItems} />
    </PermissionComponent>
  );
};
